<template>
    <div class="story">
        <el-alert style="margin-left:80px;margin-bottom:10px;width:560px;" title="如您有多个建议或问题，请分别单独提交，便于管理和反馈。"
            type="warning">
        </el-alert>
        <el-form ref="form" :model="form" :rules="rules" :disabled="!isLogin" label-width="80px" style="width:640px;">
            <el-form-item label="分类" prop="category">
                <el-select v-model="form.category" placeholder="选择业务系统，如果不确定请选‘其他’" style="width:100%">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </el-form-item>

            <el-form-item label="标题" prop="title">
                <el-input placeholder="简单概括您的建议(不超过30个字)" maxlength="30" show-word-limit
                    v-model="form.title"></el-input>
            </el-form-item>

            <el-form-item label="描述" prop="text">
                <el-input type="textarea" :autosize="{ minRows: 10, maxRows: 15 }" maxlength="2000" show-word-limit
                    placeholder="详细说说您的想法或者遇到的问题(2000个字以内)" v-model="form.text">
                </el-input>
            </el-form-item>

            <el-form-item label="上传图片">
                <el-upload :class="{ styleShow: form.piclist.length === 0, styleHide: form.piclist.length === maxPics }"
                    list-type="picture-card" :multiple='true' :limit=this.maxPics :auto-upload="true"
                    :file-list="fileList" action="api/common/upload" :before-upload="beforeUpload"
                    :on-success="eventUploadSuccess" :on-remove="eventRemove" :on-exceed="eventExceed" name="file">
                    <i slot="default" class="el-icon-plus"></i>
                    <div class="el-upload__tip" slot="tip">最多上传 {{ maxPics }} 张图片，支持JPG、PNG格式</div>
                </el-upload>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" style="margin-left:140px;width:200px" :loading="showLoading"
                    @click="onSubmit">提交</el-button>
            </el-form-item>
        </el-form>
        <el-dialog title="感谢您的支持" :visible.sync="messageDialogVisible" width="40%" center>
            <span>产品经理收到通知后，会及时进行评估和反馈。您可以点击左侧"我的"菜单查看最新处理状态。</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="messageDialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { get, post, put } from 'axios';
export default {
    data() {
        return {
            fileList: [],

            form: {
                id: '',
                title: '',
                text: '',
                content: '',
                status: '',
                creator: {
                    id: window.globalData?.user.userid || {},
                    name: window.globalData?.user.name || {}
                },
                category: '',
                piclist: []
            },
            rules: {
                category: [
                    { required: true, message: '选择业务系统，如果不确定请选‘其他’', trigger: 'change' }
                ],
                title: [
                    { required: true, message: '请用一句话概括', trigger: 'blur' }
                ],
                text: [
                    { required: true, message: '请详细描述您的需求或建议', trigger: 'blur' }
                ]
            },
            options: window.globalData?.config.categoryList || [],
            showLoading: false,
            messageDialogVisible: false,
            maxPics: 9,
            updateStory: false,
            isLogin: window.globalData?.user.userid !== undefined
        }
    },

    methods: {
        onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {

                    this.showLoading = true

                    this.form.content = this.form.text

                    for (var i = 0; i < this.form.piclist.length; i++) {
                        this.form.content = this.form.content + '<br>' + '<img src="' + this.form.piclist[i] + '">'
                    }

                    try {
                        let { data: { status, errorMsg } } = await post('api/robot/send', {
                            form: this.form
                        });

                        console.log(status)

                        if (status == '1') {
                            if (this.updateStory) {
                                let storyData = {}
                                storyData.id = this.form.id
                                storyData.creator = this.form.creator.id
                                storyData.creatorName = this.form.creator.name
                                storyData.category = this.form.category
                                storyData.title = this.form.title
                                storyData.text = this.form.text
                                storyData.piclist = ""

                                this.form.piclist.forEach(item => {
                                    storyData.piclist += item
                                    storyData.piclist += "|"
                                })

                                let len = storyData.piclist.length
                                if (len > 0) {
                                    storyData.piclist = storyData.piclist.substr(0, len - 1)
                                }

                                let { data } = await put('api/opinions/put?id=' + this.form.id, {
                                    form: storyData
                                })

                                console.log(data)

                                if (data && data.code === 0) {
                                    // this.$message.success('发送成功')
                                    this.messageDialogVisible = true
                                    this.clearFormData()
                                }
                                else {
                                    this.$message.error('发送失败: ' + errorMsg || '')
                                }
                            }
                            else {
                                // this.$message.success('发送成功')
                                this.messageDialogVisible = true
                                this.clearFormData()
                            }
                        } else {
                            this.$message.error('发送失败: ' + errorMsg || '')
                        }
                        this.showLoading = false
                    }
                    catch (err) {
                        console.log(err)
                        this.$message.error('发送失败: ' + err || '')
                        this.showLoading = false
                    }
                }
            })
        },

        clearFormData() {
            this.form = {
                id: '',
                title: '',
                text: '',
                content: '',
                status: '',
                creator: {
                    id: window.globalData?.user.userid || {},
                    name: window.globalData?.user.name || {}
                },
                category: '',
                piclist: []
            }

            this.fileList = []

            this.updateStory = false
        },

        eventUploadSuccess(response) {
            try {
                let { code, msg, data } = response;
                if (code == 0) {
                    this.form.piclist.push(data)
                    // this.$message.success('上传成功: ' + data);
                    console.log("Picture list: " + this.form.piclist)
                }
                else {
                    this.$message.error(msg);
                }
            }
            catch (error) {
                this.$message.error('上传失败');
            }
        },

        eventRemove(file) {
            console.log("Remove picture...")
            console.log(file)
            const i = this.form.piclist.findIndex(x => x === file.url)
            this.form.piclist.splice(i, 1)
            console.log(this.form.piclist)
        },

        eventExceed() {
            const tip = '最多上传 ' + this.maxPics + ' 张图片!'
            this.$message.warning(tip);
        },

        beforeUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';

            // const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG && !isPNG) {
                this.$message.warning('上传图片只能是 JPG 或 PNG 格式!');
            }
            // if (!isLt2M) {
            //     this.$message.warning('上传图片大小不能超过 2MB!');
            // }
            // return (isJPG || isPNG) && isLt2M;
            return (isJPG || isPNG)
        },

        // canEdit() {
        //     let canEdit = this.form.status === ''

        //     console.log('canEdit: ' + this.form.status)

        //     return canEdit
        // },   
    },
    async mounted() {
        this.clearFormData()

        let id = this.$route.params.id
        console.log("param:" + id)

        console.log("userid: " + window.globalData?.user.userid)
        console.log("username: " + window.globalData?.user.name)

        if (id) {
            let { data } = await get('api/opinions/get?id=' + id)
            if (data && data.code === 0) {
                console.log(data)

                let storyData = data.data

                this.form.id = storyData.id
                this.form.category = storyData.category
                this.form.title = storyData.title
                this.form.text = storyData.text
                if (storyData.piclist) {
                    this.form.piclist = storyData.piclist.split("|")
                    this.form.piclist.forEach(item => {
                        let picture = {}
                        picture.name = ""
                        picture.url = item

                        this.fileList.push(picture)
                    })
                    console.log(this.form.piclist)
                }

                this.form.category = storyData.category
                this.form.status = storyData.status

                this.updateStory = true
            }
        }
    }
}
</script>

<style>
.story {
    padding: 40px;
}

.styleShow .el-upload--picture-card {
    width: 110px;
    height: 110px;
    line-height: 110px;
}

.styleHide .el-upload--picture-card {
    display: none;
}
</style>